<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Rekapitulasi Solved
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="row px-3">
            <div class="col-12">
                <form v-on:submit.prevent="paginate(1, false)">
                    <div class="row d-md-flex d-none">
                        <div class="col-2 px-1">
                            <label class="text-muted mb-0">Filter Nama Pengajar</label>
                        </div>
                        <div class="col-2 px-1">
                            <label class="text-muted mb-0">Search</label>
                        </div>
                        <div class="col-4 px-1">
                            <label class="text-muted mb-0">Interval</label>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <select v-model="form.filter.subjectID" class="form-control form-control-sm">
                                <option value="">Pilih Mata Pelajaran...</option>
                                <option v-for="subject in subjects" v-bind:value="subject.id" v-bind:key="subject.id">{{ subject.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <input v-model="form.filter.keyword" class="form-control form-control-sm" placeholder="Search..." />
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <datepicker v-model="form.filter.start" v-bind:language="dateLanguage" full-month-name monday-first clear-button input-class="form-control form-control-sm"></datepicker>
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <datepicker v-model="form.filter.end" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{to: form.filter.start}" input-class="form-control form-control-sm"></datepicker>
                        </div>
                        <div class="col-auto px-1 mt-2">
                            <button type="submit" class="btn btn-danger btn-sm px-3">
                                Search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col">
                                    Tanggal
                                </th>
                                <th scope="col">
                                    Nama Pegawai
                                </th>
                                <th scope="col">
                                    Jumlah Solved
                                </th>
                                <th scope="col">
                                    Total Keseluruhan
                                </th>
                                <th scope="col">
                                    Mata Pelajaran
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="employee in employees" v-bind:key="employee.userID">
                                <td>
                                    <span class="text-loading">{{ [employee.solvingDate, "YYYY-MM-DD"] | moment("D MMMM YYYY") }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ employee.user.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ employee.solvingComments }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ employee.totalSolving }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ listSubjects(employee) }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import { id } from 'vuejs-datepicker/dist/locale';
    import Paginate from 'vuejs-paginate';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "ForumRecapitulation",
        directives: {dragscroll},
        components: {
            Paginate,
            Datepicker
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            'form.filter.start'(start) {
                if (start) {
                    if (!this.form.filter.end || this.$moment(start).isAfter(this.$moment(this.form.filter.end))) {
                        this.form.filter.end = start;
                    }
                }
            },
            term() {
                this.paginate(1, false);
            }
        },
        data() {
            return {
                form: {
                    filter: {
                        subjectID: '', keyword: '', start: '', end: ''
                    }
                },
                subjects: [],
                employees: [],
                pageCount: 0,
                page: 1,
                dateLanguage: id
            };
        },
        methods: {
            paginate(page, scroll = true) {
                let interval = {
                    start: this.form.filter.start ? this.$moment(this.form.filter.start).format('YYYY-MM-DD') : '',
                    end: this.form.filter.end ? this.$moment(this.form.filter.end).format('YYYY-MM-DD') : ''
                };
                this.axios.get(process.env.API_URL + '/forum/solving-commentators', {params: Object.assign({}, this.form.filter, interval, {termID: this.term.id, page: page})}).then(response => {
                    this.employees = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            listRelations(relations) {
                return typeof relations !== typeof undefined ? relations.map(object => object.name).join(', ') : '';
            },
            listSubjects(employee) {
                var subjects = [];
                if (employee.isCoordinator) {
                    subjects.push({name: employee.coordinator.subject.name});
                }
                if (employee.isTeacher) {
                    for (let i = 0; i < employee.teacher.subjects.length; i++) {
                        subjects.push({name: employee.teacher.subjects[i].name});
                    }
                }
                return this.listRelations(subjects.filter((value, index, array) => array.indexOf(value) === index));
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/subject').then(response => {
                this.subjects = response.data.data;
            });
        },
        mounted() {
            this.paginate(1, false);
            document.title = 'Rekapitulasi Solved - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/Recapitulation.vue